import script from "./RoomDataMatrixCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomDataMatrixCell.vue?vue&type=script&setup=true&lang=ts"

import "./RoomDataMatrixCell.vue?vue&type=style&index=0&id=602d11ea&scoped=true&lang=css"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-602d11ea"]])

export default __exports__